import { ReactNode } from 'react';
import { Result } from 'antd';

interface Props {
  title: string,
  status?: any,
  subTitle?: string,
  extra?: ReactNode
}

const PageCode = (props: Props) => {
  const status = props.status ?? "404";

  return (
    <Result
      status={status}
      title={props.title}
      subTitle={props.subTitle}
      extra={props.extra}
    />
  );
};

export default PageCode;